export const environment = {
  production: process.env["ISPRODUCTION"],
  clientId: process.env["AUTH_CLIENT_CLIENTID"],
  authority: "https://login.microsoftonline.com/329e91b0-e21f-48fb-a071-456717ecc28e",
  validateAuthority: true,
  redirectUri: process.env["AUTH_CLIENT_REDIRECTURI"],
  postLogoutRedirectUri: process.env["AUTH_CLIENT_POSTLOGOUTREDIRECTURI"],
  navigateToLoginRequestUrl: true, 
  subscription: process.env["SUBSCRIPTION"],
  environment: process.env["environment"],
  platformApi_client_resourceUri: process.env["PLATFORMAPI_CLIENT_RESOURCEURI"],
  platformApi_client_resourceScope: process.env["PLATFORMAPI_CLIENT_RESOURCESCOPE"],
  notificationApi_client_resourceUri: "https://totalr4platformnotification-cidi.azurewebsites.net/",
  notificationApi_client_resourceScope: "api://38523345-ce40-4f68-9a1b-4d58329d934e/access_as_user_APIM", 
  moveTagMasterMsg: "Move to Pre-Production",
  appInsightKey: process.env["APPINSIGHTKEY"],
  apim_urls: process.env["apim_urls"],
  platformHubUrl: process.env["PLATFORMHUBURL"],
  platformAdminUrl: process.env["PLATFORMADMINURL"],
  platformDocumentation: process.env["PLATFORMDOCUMENTATION"],
  cache_client: {
    cacheLocation: "localStorage"
  },
  ReleaseDetails: {
    Version: "1.0.0",
    DateOfBuild: "NA",
    BuildNumber: "NA"
  },
  groups_client_PlatformAdminGroupId: process.env["GROUPS_CLIENT_PLATFORMADMINGROUPID"],
  graphApi_client_resourceUri: "https://graph.microsoft.com/v1.0/me/memberOf",
  graphApi_client_resourceScope: "User.Read",
};